import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { useAlertStore } from '.';
// import { updateLicenses } from './account.store';
// import router from '@/router';

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

export const useApiKeyStore = defineStore('apikey', {
  state: () => ({
    apikey: '',
    docs: ''
  }),
  actions: {
    async getApiDocs(lang) {
      const alertStore = useAlertStore();
      try {
        const res = await fetchWrapper.get(`${baseUrl}/api/docs?lang=${encodeURIComponent(lang || 'en')}`);
        if (res.status) {
          this.docs = res.text;
        }
      } catch (error) {
        console.error(error)
        alertStore.error(error);
      }
    },
    async generateApiKey() {
      const alertStore = useAlertStore();
      try {
        const res = await fetchWrapper.get(`${baseUrl}/api/generate`);
        if(res.status){
          this.apikey = res.apikey;
          alertStore.success("Created New Api Key")
        }
      } catch (error) {
        alertStore.error(error);
      }
    },
    async getApiKey() {
      const alertStore = useAlertStore();
      try {
        const res = await fetchWrapper.get(`${baseUrl}/api/get`);
        if(res.status)
          this.apikey = res.apikey;
      } catch (error) {
        alertStore.error(error);
      }
    },
    async deleteApiKey() {
      const alertStore = useAlertStore();
      try {
        const res = await fetchWrapper.delete(`${baseUrl}/api/delete`);
        if(res.status){
          this.apikey = '';
          alertStore.success("The API key has been deleted successfully.");
        }
      } catch (error) {
        alertStore.error(error);
      }
    },
  },
});